import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const HubRendererLoader: LoadableType<any> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-hub-renderer" */ './hub-renderer/HubRenderer.tsx'))
			.HubRendererComponent,
});
